import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import betTableSelector from 'common/selectors/betTableSelector';
import betSlipSelector, { getReserves } from 'common/selectors/betSlipSelector';
import combinationsCountSelector from 'common/selectors/combinationsCountSelector';
import {
    getCombinedTrackName,
    getTrackFromRacingCard,
} from 'common/selectors/trackSelector';
import RacingCard from 'common/DataObjects/RacingCard';
import racesSelector from 'common/selectors/racesSelector';
import { isMultitrackProduct } from 'common/selectors/multipleTrackSetupsSelector';
import { getMultitrackLegs } from 'common/selectors/raceDaySelector';
import productSelector from 'common/selectors/productSelector';

class BetProvider extends Component {
    render() {
        const betData = { ...this.props };
        delete betData.children;

        return <Fragment>{this.props.children(betData)}</Fragment>;
    }
}

const mapStateToProps = (state) => {
    const raceNumber = state.AISDataProvider.selectedRaceNumber;
    const racingCard = RacingCard.fill(state.AISDataProvider);
    const isMultitrack = isMultitrackProduct(state);

    const ready =
        state.AISDataProvider.racingCardFetched && !racingCard.isNull();

    if (ready) {
        const betSlip = betSlipSelector(state);
        const product = productSelector(state);
        const track = getTrackFromRacingCard(state);
        const date = racingCard.date;

        return {
            ready,
            date,
            race: product.isVProduct()
                ? racingCard.races[0]
                : racingCard.races.find((r) => r.raceNumber === raceNumber),
            raceNumber,
            raceIndex: state.AISDataProvider.raceIndex,
            races: racesSelector(state),
            betSlip,
            combinedTrackName: getCombinedTrackName(state),
            trackCode: track.code,
            product,
            bet: betTableSelector(state),
            rawPool: state.AISDataProvider.trackPool,
            availableRaceNumbers: racingCard.races.map(
                (race) => race.raceNumber
            ),
            combinationsCount: combinationsCountSelector(state),
            serverTime: state.AISDataProvider.serverTime,
            isMultitrackProduct: isMultitrack,
            multitrackLegs: getMultitrackLegs(state),
            tracks: state.AISDataProvider.tracks,
            reserves: getReserves(state),
        };
    } else {
        return { ready };
    }
};

export default connect(mapStateToProps)(BetProvider);
